import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import SectionHeader from "../../../../util/component/SectionHeader";
import { pendingListCountState } from "./recoil";
import FilterPendingList from "./_components/filter-pending-list/FilterPendingList";
import TablePendingList from "./_components/table-pending-list/TablePendingList";

const PendingListPage = () => {

    const { t } = useTranslation('booking');

    const pendingListCount = useRecoilValue(pendingListCountState);

    return (
        <>
            <SectionHeader
                title={t("label.pendingList")}
                subtitle={
                    t("label.total") + ': ' + pendingListCount
                }
            />
            <Stack rowGap={3} p={3}>
                <FilterPendingList />
                <TablePendingList />
            </Stack>
        </>
    );
};

export default PendingListPage;